import React, { Component } from 'react';
import { TableBody } from '@mui/material';
import { StyledTableRow, StyledTableCell } from '../../../../uiComponents/MuiTable/StyledTable'
import MuiTableHeader from '../../../../uiComponents/MuiTable/MuiTableHeader';
import { stableSort, getComparator } from '../../../../uiComponents/MuiTable/MuiHelper';


// Main function to render table by type
export const renderTableByTableType = (table, index, i, handleRequestSort,sectionName) => {
  switch (table.tableName) {
    case "RCVS": return renderRCVSTable(table, index, i, handleRequestSort,sectionName);
    case "gnomadRace": return renderGnomadTable(table, index, i, handleRequestSort,"Race",sectionName);
    case "gnomadSex": return renderGnomadTable(table, index, i, handleRequestSort,"Sex",sectionName);
    case "oneKg":     return renderOneKgTable(table, index, i, handleRequestSort,sectionName);
    default: return renderElementWithDescriptionTable(table, index, i, handleRequestSort,sectionName);
  }
}

// Construct json rows for gnomAD by Race and Sex 
const gnomadRace = [{ 'African': 'afr' }, { 'Amish': 'ami' }, { 'Latino': 'amr' }, 
                    { 'East Asian': 'eas'},{ 'Finish': 'fin' }, { 'Non-Finish European': 'nfe' },
                    { 'Ashkenazi Jewish': 'asj' }, { 'South Asian': 'sas' }, { 'Middle Eastern': 'mid' }, 
                    { 'Other': 'remaining' }, { 'All': 'all' }];
const gnomadSex = [{ 'Male': 'male' }, { 'Female': 'female' }, { 'All': 'all' }];
const gnomadField = ['Ac', 'Af', 'An', 'Hc'];

export const renderGnomadRaceRows = (element) => {
  const rows = [];
  gnomadRace.map((item) => {
    const [race, value] = Object.entries(item)[0];
    var row = { "race": race }
    gnomadField.forEach((field) => {
      var key = value + field
      row[field] = element[key]
    });
    rows.push(row)
  });
  return rows;
};
export const renderGnomadSexRows = (element) => {
  const rows = [];
  gnomadSex.map((item) => {
    const [race, value] = Object.entries(item)[0];
    var row = { "race": race }
    gnomadField.forEach((field) => {
      var key = value + field
      row[field] = element[key]
    });
    rows.push(row)
  });
  return rows;
};

// Construct json rows for OneKg
const oneKRace = [{ 'African': 'afr' }, { 'Latino': 'amr' }, { 'East Asian': 'eas' },
                  { 'European': 'eur' },{ 'South Asian': 'sas' }, { 'All': 'all' }];
const oneKField = ['Ac', 'Af', 'An']
export const renderOneKgRows = (element) => {
  const rows = [];
  oneKRace.map((item) => {
    const [race, value] = Object.entries(item)[0];
    var row = { "race": race }
    oneKField.forEach((field) => {
      var key = value + field
      row[field] = element[key]
    });
    rows.push(row)
  });
  return rows;
};


const renderRCVSTable = (table, index, i, handleRequestSort,sectionName) => {
  const rcvsColumns = [
    { label: 'Classification', id: 'classification', numeric: false, disablePadding: false },
    { label: 'Date Last Evaluated', id: 'dateLastEvaluated', numeric: false, disablePadding: false },
    { label: 'Review Status', id: 'reviewStatus', numeric: false, disablePadding: false },
  ]; 
  
  // Ensure rows exist and is an array
  if (!table.rows || !Array.isArray(table.rows) || table.rows.length === 0) {
    return (<>
      <MuiTableHeader
        headCells={rcvsColumns}
        order={table.order}
        orderBy={table.orderBy}
        onRequestSort={(event, property) => handleRequestSort(index, i, property)} />
      <TableBody>
        <StyledTableRow>
          <StyledTableCell colSpan={3}>No RCV data available</StyledTableCell>
        </StyledTableRow>
      </TableBody>
    </>);
  }
  
  return (<>
    <MuiTableHeader
      headCells={rcvsColumns}
      order={table.order}
      orderBy={table.orderBy}
      onRequestSort={(event, property) => handleRequestSort(index, i, property)} />
    <TableBody>
      {stableSort(table.rows, getComparator(table.order, table.orderBy)).map((row, rowIndex) => (
        <StyledTableRow tabIndex={-1} key={`${sectionName}-${table.tableName}-${rowIndex}`}>
          <StyledTableCell style={{ width: '33%' }}>{row.classification || ''}</StyledTableCell>
          <StyledTableCell style={{ width: '33%' }}>{row.dateLastEvaluated || ''}</StyledTableCell>
          <StyledTableCell style={{ width: '33%' }}>{row.reviewStatus || ''}</StyledTableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  </>);
};

const renderElementWithDescriptionTable = (table, index, i, handleRequestSort,sectionName) => {
  const descColumns = [
    { label: 'Name', id: 'key', numeric: false, disablePadding: false },
    { label: 'Value', id: 'value', numeric: false, disablePadding: false },
    { label: 'Description', id: 'description', numeric: false, disablePadding: false },
  ];
  return (<>
    <MuiTableHeader
      headCells={descColumns}
      order={table.order}
      orderBy={table.orderBy}
      onRequestSort={(event, property) => handleRequestSort(index, i, property)} />
    <TableBody>
      {stableSort(table.rows, getComparator(table.order, table.orderBy)).map((row, rowIndex) => (
        <StyledTableRow tabIndex={-1} key={`${sectionName}-${table.tableName}-${rowIndex}`}>
          <StyledTableCell style={{ width: '33%' }}>{row.key}</StyledTableCell>
          <StyledTableCell style={{ width: '33%' }}>{valueCell(row)}</StyledTableCell>
          <StyledTableCell style={{ width: '33%' }}>{row.description}</StyledTableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  </>);
}
const renderGnomadTable = (table, index, i, handleRequestSort,type,sectionName) => {
  const gnomadColumns = [
    { label: type, id: type, numeric: false, disablePadding: false },
    { label: 'Allele Count', id: 'Ac', numeric: true, disablePadding: false },
    { label: 'Allele Frequency', id: 'Af', numeric: true, disablePadding: false },
    { label: 'Allele Number (N)', id: 'An', numeric: true, disablePadding: false },
    { label: 'Homozygous Count', id: 'Hc', numeric: true, disablePadding: false },
  ];
  return (<>
    <MuiTableHeader
      headCells={gnomadColumns}
      order={table.order}
      orderBy={table.orderBy}
      onRequestSort={(event, property) => handleRequestSort(index, i, property)} />
    <TableBody>
      {stableSort(table.rows, getComparator(table.order, table.orderBy)).map((row, rowIndex) => (
        <StyledTableRow tabIndex={-1} key={`${sectionName}-${type}-${rowIndex}`}>
          <StyledTableCell >{row.race}</StyledTableCell>
          <StyledTableCell align='right'>{row.Ac}</StyledTableCell>
          <StyledTableCell align='right'>{row.Af}</StyledTableCell>
          <StyledTableCell align='right'>{row.An}</StyledTableCell>
          <StyledTableCell align='right'>{row.Hc}</StyledTableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  </>);
};

const renderOneKgTable = (table, index, i, handleRequestSort,sectionName) => {
  const oneKgColumns = [
    { label: 'Race', id: "race", numeric: false, disablePadding: false },
    { label: 'Allele Count', id: 'Ac', numeric: true, disablePadding: false },
    { label: 'Allele Frequency', id: 'Af', numeric: true, disablePadding: false },
    { label: 'Allele Number (N)', id: 'An', numeric: true, disablePadding: false },
  ];
  return (<>
    <MuiTableHeader
      headCells={oneKgColumns}
      order={table.order}
      orderBy={table.orderBy}
      onRequestSort={(event, property) => handleRequestSort(index, i, property)} />
    <TableBody>
      {stableSort(table.rows, getComparator(table.order, table.orderBy)).map((row, rowIndex) => (
        <StyledTableRow tabIndex={-1} key={`${sectionName}-${table.tableName}-${rowIndex}`}>
          <StyledTableCell >{row.race}</StyledTableCell>
          <StyledTableCell align='right'>{row.Ac}</StyledTableCell>
          <StyledTableCell align='right'>{row.Af}</StyledTableCell>
          <StyledTableCell align='right'>{row.An}</StyledTableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  </>);
};

const valueCell = (row) => {
  ////////// constant variables ///////////////////////////
  const dbSnpUrlBase = "https://www.ncbi.nlm.nih.gov/snp/";
  const clinvarUrlBase = "https://www.ncbi.nlm.nih.gov/clinvar/";
  const omimUrlBase = "https://www.omim.org/entry/";
  const pubMedUrlBase = "https://pubmed.ncbi.nlm.nih.gov/";
  const medGenUrlBase = "https://www.ncbi.nlm.nih.gov/medgen/?term=";
  ////////////////////////////////////////////////////////
  //  Function to check for empty values
  //  This is used to determine if a value should be rendered as an empty string
  const checkForEmptyValue = (value) => {
       return value === null || value === undefined || value === "";
  }

  const { key, value } = row;

  //  OMIM IDs. In some cases, they may be encased in quotes (like in Hbvar)
  if (String(key).toLowerCase().startsWith("omim")) {
   
    if (checkForEmptyValue(value)) return "";

    var ids = String(value).replace(/^"|"$/g, '').trim().split(",");
    var values = [];
    for (let i = 0; i < ids.length; i++) {
      const omimId = String(ids[i]).split('.')[0];
      values.push(<a target="_blank" key={omimId} href={omimUrlBase + omimId}>{omimId}</a>);
      if (i < (ids.length - 1)) {
        values.push((", "));
      }
    }
    return values;


  }

  if (String(key).toLowerCase().startsWith("medgen")) {
    // Handle the case where the key starts with "MedGen" (case insensitive)
    return (<a target="_blank" key={value} href={medGenUrlBase + String(value)}>{value}</a>);
  }

  // If value is an array, join it with comma separator. This section handles dbsnp IDs and pubmed IDs that are
  //    contained within Clinvar entries from Nirvana. IDs from non-Nirvana sources are handled elsewhere
  if (Array.isArray(value)) {
    var values = [];
    for (let i = 0; i < value.length; i++) {
      // Check for dbSnp value. This value will always be in an array in Nirvana
      if (String(value[i]).startsWith("rs")) {
        values.push((<a target="_blank" key={value[i]} href={dbSnpUrlBase + value[i]}>{value[i]}</a>));
      } else if (String(key).toLowerCase().startsWith("pubmed")) {
        // Handle the case where the key starts with "PubMed" (case insensitive)
        values.push((<a target="_blank" key={value[i]} href={pubMedUrlBase + value[i]}>{value[i]}</a>));
      } else {
        values.push((value[i]));
      }

      if (i < (value.length - 1)) {
        values.push((", "));
      }
    }
    return <>{values}</>;
  }

  //  For dbsnp IDs outside of Nirvana (e.g. HbVar) where they're not in an array
  if (String(key).toLowerCase().startsWith("dbsnp")) {
    if (checkForEmptyValue(value)) return "";
    
    var ids = value.replace(/^"|"$/g, '').trim().split(",");
    var values = [];
    for (let i = 0; i < ids.length; i++) {
      values.push((<a target="_blank" key={ids[i]} href={dbSnpUrlBase + ids[i]}>{ids[i]}</a>));
      if (i < (ids.length - 1)) {
        values.push((", "));
      }
    }

    return <>{values}</>;

  }

  //  For pubmed IDs outside of Nirvana (e.g. HbVar) where they're not in an array
  if (String(key).toLowerCase().startsWith("pubmed")) {
    if (checkForEmptyValue(value)) return "";
    // console.log("PubMed value: ", value);
    var ids = value.replace(/^"|"$/g, '').trim().split(",");
    var values = [];
    for (let i = 0; i < ids.length; i++) {
      values.push((<a target="_blank" key={ids[i]} href={pubMedUrlBase + ids[i]}>{ids[i]}</a>));
      if (i < (ids.length - 1)) {
        values.push((", "));
      }
    }

    return <>{values}</>;

  }

  //  Check for a hyperlinkable value (VCV and RCV numbers for ClinVar)
  if (String(value).toLowerCase().startsWith("vcv")) {
    return (<a target="_blank" key={value} href={clinvarUrlBase + "variation/" + String(value).split('.')[0].replace(/^(VCV)0+/, '')}>{value}</a>);
  }

  if (String(value).toLowerCase().startsWith("rcv")) {
    const rcvVal = String(value).split('.')[0];
    return (<a target="_blank" key={value} href={clinvarUrlBase + rcvVal}>{value}</a>);
  }

  return <span>{value}</span>;
};

